module.exports = __webpack_public_path__ + "static/img/ztDefault.efb7146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ztDefault.png
// module id = rUWf
// module chunks = 2